export function getLocalization() {
    return window.__LOCALIZATION__
}
